import TYPES from "@/constant/types";

const TOKEN_INVALID_PATTERN = /(?:token|令牌).*(?:失效|无效|过期|错误|异常)|(?:失效|无效|过期).*(?:token|令牌)|请重新登录|登录已过期|登录失效|invalid\s*token|token\s*(?:is\s*)?(?:invalid|expired)|expired\s*token|please\s*(?:re)?login/i;
const CLOCK_SKEW_MS = 30 * 1000;

export function decodeJwtPayload(token) {
	if (!token || typeof token !== "string") return null;
	const parts = token.split(".");
	if (parts.length !== 3) return null;

	try {
		const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
		const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
		const binary = window.atob(padded);
		const json = decodeURIComponent(
			binary
				.split("")
				.map(char => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
				.join("")
		);
		const payload = JSON.parse(json);
		return payload && typeof payload === "object" ? payload : null;
	} catch (e) {
		return null;
	}
}

export function getTokenExpiry(token) {
	const payload = decodeJwtPayload(token);
	if (!payload) return null;
	const exp = Number(payload.exp);
	if (!isFinite(exp)) return null;
	return exp * 1000;
}

export function getTokenState(token, now = Date.now()) {
	if (!token) return "missing";
	const expiry = getTokenExpiry(token);
	if (expiry === null) return "unknown";
	return expiry <= now + CLOCK_SKEW_MS ? "expired" : "valid";
}

export function isTokenInvalidMessage(message) {
	return TOKEN_INVALID_PATTERN.test(String(message || ""));
}

export function getCrmLoginPath() {
	return process.env.NODE_ENV === "development" ? "/crm/pLogin" : "/crm/login";
}

export function isCrmAuthRedirectRequest(to) {
	const query = (to && to.query) || {};
	return !!(
		query.redirectUri ||
		query.redirect_uri ||
		query.responseType === "code" ||
		query.response_type === "code"
	);
}

export function clearCrmAuthStorage() {
	localStorage.removeItem(TYPES.STAFF_TOKEN);
	localStorage.removeItem(TYPES.STAFF_INFO);
	localStorage.removeItem(TYPES.UI_CACHE_DB_DICT_DATA);
	sessionStorage.removeItem("userId");
	sessionStorage.removeItem("realname");
	sessionStorage.removeItem("username");
}
